export default {"src":"/_next/static/media/car_on_fire.48179722.svg","height":100,"width":150};